var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 36,
    r: 30,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0919 30.4057L26.1512 27.9341C26.8528 26.297 27.8603 24.8089 29.1197 23.5495L46.6587 6.01049C49.5876 3.08155 54.3364 3.08155 57.2653 6.01049C60.1942 8.93942 60.1942 13.6882 57.2653 16.6171L39.7263 34.1561C38.4669 35.4155 36.9788 36.423 35.3417 37.1246L32.8701 38.1838L25.0919 30.4057Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3137 33.9412L25.0919 31.8199L31.4558 38.1838L29.3345 45.962L12.7175 51.9724L23.3241 41.3658C23.7146 40.9753 23.7146 40.3421 23.3241 39.9516C22.9336 39.5611 22.3004 39.5611 21.9099 39.9516L11.3033 50.5582L17.3137 33.9412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPanel);
export default __webpack_public_path__ + "static/media/btnPanel.1b73f20226e66585e6dfb6654e41dba4.svg";
export { ForwardRef as ReactComponent };